import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { usePqrInfo } from './hook';
import { PqrInfoProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const PqrInfo = (props: PqrInfoProps) => {
    const { formik, status, countries, locations, isColombiaCountry } =
        usePqrInfo(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Información PQR
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(status)}
                    label="Estado"
                    name="status"
                    size="small"
                    required
                    disabled={status.length < 2}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('status', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(countries)}
                    label="País"
                    name="country"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.country}
                    errors={formik.errors.country}
                    value={formik.values.country}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('country', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(locations)}
                    label="Ubicación PQR"
                    name="location"
                    size="small"
                    required={!!isColombiaCountry}
                    disabled={!isColombiaCountry}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.location}
                    errors={formik.errors.location}
                    value={formik.values.location}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('location', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Radicado de correspondencia"
                    name="correspondenceFiling"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.correspondenceFiling}
                    errors={formik.errors.correspondenceFiling}
                    value={formik.values.correspondenceFiling}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Detalle de PQR"
                    name="detail"
                    size="small"
                    required
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.detail}
                    errors={formik.errors.detail}
                    value={formik.values.detail}
                    onChange={formik.handleChange}
                    maxLength={4500}
                />
            </Grid>
        </Grid>
    );
};
